"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carouselRemoveButtonStyles = void 0;
const styles_1 = require("../CarouselSlideAddButton/styles");
exports.carouselRemoveButtonStyles = {
    root: styles_1.buttonStyles,
    icon: { width: "15px", marginLeft: "3px" },
};
//# sourceMappingURL=styles.js.map